import React, { use } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  LinearProgress,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getAllFarmerCommitmentsAction,getAllPostSeasonActivitiesAction, getAllPreSeasonActivitiesAction,getAllSalesTargetsAction, getAllDailyTasksAction,} from "../../../store/actions";
const SOorMDODashboard = () => {
    const dispatch = useDispatch();
 const { successData: farmerCommitmentsData } = useSelector((state) => state.getAllFarmerCommitmentsReducer);
 const { successData: preSeasonData } = useSelector((state) => state.getAllPreSeasonActivitiesReducer);
 const { successData: postSeasonData } = useSelector((state) => state.getAllPostSeasonActivitiesReducer);
 const { successData: salesTargetsData } = useSelector((state) => state.getAllSalesTargetsReducer);
 const { successData: dailyTasksData } = useSelector((state) => state.getAllDailyTasksReducer);

 useEffect(() => {
    dispatch(getAllFarmerCommitmentsAction());
    dispatch(getAllPreSeasonActivitiesAction());
    dispatch(getAllPostSeasonActivitiesAction());
    dispatch(getAllSalesTargetsAction());
    dispatch(getAllDailyTasksAction());
  }, [dispatch]);
  return (
    <Box sx={{ p: { xs: 1, md: 4 }, minHeight: "100vh" ,mt:{xs:7,sm:0}}}>
      {/* MOBILE: Single Card for all details */}
      <Box sx={{ display: { xs: "flex", sm: "none" } ,minHeight: "100vh", display: "flex", flexDirection: "column"}}>
        <Card sx={{ p: 2, borderRadius: 3, 
    display: "flex", 
    flexDirection: "column" 
 }}>
          <Typography sx={{ fontWeight: 700, mb: 1, color: "#4b5563" }}>
            FARMER COMMITMENTS
          </Typography>
          <Grid container spacing={1} sx={{ mb: 1, flex: 1 }}>
            {/* Pending Leads Sub-card */}
            <Grid item size={{xs:6}}>
              <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                <Typography color="#6b7280" fontSize={13}>Pending Leads</Typography>
                <Typography variant="h6" fontWeight={700}>
                  {farmerCommitmentsData?.pendingCount ?? 0}
                </Typography>
              </Box>
            </Grid>
            {/* Acres Target Sub-card */}
            <Grid item size={{xs:6}}>
              <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                {(() => {
                  const committed = Number(salesTargetsData?.overall_totals?.no_acres_comm ?? 0);
                  const required = Number(salesTargetsData?.overall_totals?.farmer_comm_acre_required ?? 0);
                  const percent = required > 0 ? Math.round((committed / required) * 100) : 0;
                  return (
                    <>
                      <Typography color="#6b7280" fontSize={13}>Acres Target</Typography>
                      <Typography variant="body2" fontWeight={600}>
                        {committed} / {required}
                      </Typography>
                      <Box sx={{ width: '100%', mt: 0.5 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">
                              {percent}%
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
          </Grid>
          {/* PRE ACTIVITIES */}
          <Box sx={{ mt: 4, minHeight: "100%" }}>
            <Typography sx={{ fontWeight: 700, color: "#475569", mb: 1, letterSpacing: 1, fontSize: 15 }}>
              PRE ACTIVITIES
            </Typography>
            <Grid container spacing={1}>
              {/* VLM Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                  {(() => {
                    const vlmDone = Number(preSeasonData?.overall_totals?.vlm_done_count ?? 0);
                    const vlmCount = Number(preSeasonData?.overall_totals?.vlm_count ?? 0);
                    const vlmPercent = vlmCount > 0 ? Math.round((vlmDone / vlmCount) * 100) : 0;
                    return (
                      <>
                        <Typography variant="subtitle2" color="primary" fontSize={13}>VLM</Typography>
                        <Typography variant="body2" fontWeight={600}>{vlmDone} / {vlmCount}</Typography>
                        <Box sx={{ width: '100%', mt: 0.5 }}>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                              <Box sx={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={vlmPercent}
                                  sx={{ borderRadius: 5, height: 8 }}
                                  color={vlmPercent >= 100 ? 'success' : 'primary'}
                                />
                              </Box>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption" color="#9ca3af">{vlmPercent}%</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Grid>
              {/* MVLM Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                  {(() => {
                    const mvlmDone = Number(preSeasonData?.overall_totals?.mvlm_done_count ?? 0);
                    const mvlmCount = Number(preSeasonData?.overall_totals?.mvlm_count ?? 0);
                    const mvlmPercent = mvlmCount > 0 ? Math.round((mvlmDone / mvlmCount) * 100) : 0;
                    return (
                      <>
                        <Typography variant="subtitle2" color="primary" fontSize={13}>MVLM</Typography>
                        <Typography variant="body2" fontWeight={600}>{mvlmDone} / {mvlmCount}</Typography>
                        <Box sx={{ width: '100%', mt: 0.5 }}>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                              <Box sx={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={mvlmPercent}
                                  sx={{ borderRadius: 5, height: 8 }}
                                  color={mvlmPercent >= 100 ? 'success' : 'primary'}
                                />
                              </Box>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption" color="#9ca3af">{mvlmPercent}%</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Grid>
              {/* FARMERS Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                  {(() => {
                    const farmersAttended = Number(preSeasonData?.overall_totals?.farmers_attended ?? 0);
                    const farmersRequired = Number(preSeasonData?.overall_totals?.farmers_required ?? 0);
                    const farmersPercent = farmersRequired > 0 ? Math.round((farmersAttended / farmersRequired) * 100) : 0;
                    return (
                      <>
                        <Typography variant="subtitle2" color="primary" fontSize={13}>FARMERS</Typography>
                        <Typography variant="body2" fontWeight={600}>{farmersAttended} / {farmersRequired}</Typography>
                        <Box sx={{ width: '100%', mt: 0.5 }}>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                              <Box sx={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={farmersPercent}
                                  sx={{ borderRadius: 5, height: 8 }}
                                  color={farmersPercent >= 100 ? 'success' : 'primary'}
                                />
                              </Box>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption" color="#9ca3af">{farmersPercent}%</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Grid>
            </Grid>
            {/* FARMERS */}
           
          </Box>
          {/* POST ACTIVITIES */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ fontWeight: 700, color: "#475569", mb: 1, letterSpacing: 1, fontSize: 15 }}>
              POST ACTIVITIES
            </Typography>
            <Grid container spacing={1}>
              {/* DV Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                  {(() => {
                    const dvDone = Number(postSeasonData?.overall_totals?.dv_done_count ?? 0);
                    const dvCount = Number(postSeasonData?.overall_totals?.dv_count ?? 0);
                    const dvPercent = dvCount > 0 ? Math.round((dvDone / dvCount) * 100) : 0;
                    return (
                      <>
                        <Typography variant="subtitle2" color="primary" fontSize={13}>DV</Typography>
                        <Typography variant="body2" fontWeight={600}>{dvDone} / {dvCount}</Typography>
                        <Box sx={{ width: '100%', mt: 0.5 }}>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                              <Box sx={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={dvPercent}
                                  sx={{ borderRadius: 5, height: 8 }}
                                  color={dvPercent >= 100 ? 'success' : 'primary'}
                                />
                              </Box>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption" color="#9ca3af">{dvPercent}%</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Grid>
              {/* FV Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                  {(() => {
                    const fvDone = Number(postSeasonData?.overall_totals?.fv_done_count ?? 0);
                    const fvCount = Number(postSeasonData?.overall_totals?.fv_count ?? 0);
                    const fvPercent = fvCount > 0 ? Math.round((fvDone / fvCount) * 100) : 0;
                    return (
                      <>
                        <Typography variant="subtitle2" color="primary" fontSize={13}>FV</Typography>
                        <Typography variant="body2" fontWeight={600}>{fvDone} / {fvCount}</Typography>
                        <Box sx={{ width: '100%', mt: 0.5 }}>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                              <Box sx={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={fvPercent}
                                  sx={{ borderRadius: 5, height: 8 }}
                                  color={fvPercent >= 100 ? 'success' : 'primary'}
                                />
                              </Box>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption" color="#9ca3af">{fvPercent}%</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Grid>
              {/* FD Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: '#f3f4f6', p: 1.2, borderRadius: 2, height: '100%' }}>
                  {(() => {
                    const fdDone = Number(postSeasonData?.overall_totals?.fd_done_count ?? 0);
                    const fdCount = Number(postSeasonData?.overall_totals?.fd_count ?? 0);
                    const fdPercent = fdCount > 0 ? Math.round((fdDone / fdCount) * 100) : 0;
                    return (
                      <>
                        <Typography variant="subtitle2" color="primary" fontSize={13}>FD</Typography>
                        <Typography variant="body2" fontWeight={600}>{fdDone} / {fdCount}</Typography>
                        <Box sx={{ width: '100%', mt: 0.5 }}>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                              <Box sx={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={fdPercent}
                                  sx={{ borderRadius: 5, height: 8 }}
                                  color={fdPercent >= 100 ? 'success' : 'primary'}
                                />
                              </Box>
                            </Grid>
                            <Grid item>
                              <Typography variant="caption" color="#9ca3af">{fdPercent}%</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Grid>
            </Grid>
            {/* FD */}
        
          </Box>
          {/* DAILY TASKS */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ fontWeight: 700, color: "#475569", mb: 1, letterSpacing: 1, fontSize: 15 }}>
              DAILY TASKS
            </Typography>
            <Grid container spacing={1} mb={2}>
              {/* TOTAL TASKS Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: "#f3f4f6", p: 1.2, borderRadius: 2, height: '100%' }}>
                  <Typography variant="caption">TOTAL TASKS</Typography>
                  <Typography variant="body2">{dailyTasksData?.total_records_count ?? 0}</Typography>
                </Box>
              </Grid>
              {/* PENDING Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: "#f3f4f6", p: 1.2, borderRadius: 2, height: '100%' }}>
                  <Typography variant="caption">PENDING</Typography>
                  <Typography variant="body2" color="#b45309">{dailyTasksData?.assigned_task_count ?? 0}</Typography>
                </Box>
              </Grid>
              {/* COMPLETED Sub-card */}
              <Grid item size={{xs:4}}>
                <Box sx={{ bgcolor: "#f3f4f6", p: 1.2, borderRadius: 2, height: '100%' }}>
                  <Typography variant="caption">COMPLETED</Typography>
                  <Typography variant="body2" color="#047857">{dailyTasksData?.completed_task_count ?? 0}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Box>
      {/* DESKTOP/TABLET: Original layout, hidden on xs */}
      <Box sx={{ display: { xs: "none", sm: "none" } }}>
        {/* ...existing code... (original layout here) ... */}
         {/* ================= HEADER TITLE ================= */}
  

  {/* ================= TOP CARDS ================= */}
  <Grid container spacing={2}>
    <Grid item size={{ xs: 12,sm:6 }}>
      <Card sx={{ p: 2.5, borderRadius: 3 }}>
        <Typography sx={{  fontWeight: 600, color: '#475569', letterSpacing: 1  }}>
    FARMER COMMITMENTS
  </Typography>
        <Typography color="#6b7280">Pending Leads</Typography>
        <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>{farmerCommitmentsData?.pendingCount ?? 0}</Typography>
        {(() => {
          const committed = Number(salesTargetsData?.overall_totals?.no_acres_comm ?? 0);
          const required = Number(salesTargetsData?.overall_totals?.farmer_comm_acre_required ?? 0);
          const percent = required > 0 ? Math.round((committed / required) * 100) : 0;
          return (
            <>
              <Typography color="#6b7280" sx={{ mt: 1 }}>Acres Target</Typography>
              <Typography variant="h6" fontWeight={600}>
                {committed} / {required}
              </Typography>
              <Box sx={{ width: '100%', mt: 1 }}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs>
                    <Box sx={{ width: '100%' }}>
                      <LinearProgress
                        variant="determinate"
                        value={percent}
                        sx={{ borderRadius: 5, height: 10 }}
                        color={percent >= 100 ? 'success' : 'primary'}
                      />
                    </Box>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption" color="#9ca3af">
                      {percent}%
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </>
          );
        })()}
      </Card>
    </Grid>
    <Grid item size={{ xs: 12, sm:6 }}>
     <Card sx={{ borderRadius: 3, overflow: "hidden", mb: 2 }}>
        {/* HEADER */}
        <Box sx={{  px: 2, py: 1.5,  }}>
          <Typography sx={{ fontWeight: 600, color: '#475569', letterSpacing: 1 }}>
            PRE ACTIVITIES
          </Typography>
        </Box>
        {/* CONTENT */}
        <Box sx={{ p: 2 }}>
          <Grid container spacing={2}>
            {/* VLM */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box sx={{ bgcolor: "#f9fafb", p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="primary">VLM</Typography>
                {(() => {
                  const done = Number(preSeasonData?.overall_totals?.vlm_done_count ?? 0);
                  const total = Number(preSeasonData?.overall_totals?.vlm_count ?? 0);
                  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
                  return (
                    <>
                      <Typography variant="body2" fontWeight={600}>{done} / {total}</Typography>
                      <Box sx={{ width: '100%', mt: 1 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">{percent}%</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
            {/* MVLM */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box sx={{ bgcolor: "#f9fafb", p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="primary">MVLM</Typography>
                {(() => {
                  const done = Number(preSeasonData?.overall_totals?.mvlm_done_count ?? 0);
                  const total = Number(preSeasonData?.overall_totals?.mvlm_count ?? 0);
                  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
                  return (
                    <>
                      <Typography variant="body2" fontWeight={600}>{done} / {total}</Typography>
                      <Box sx={{ width: '100%', mt: 1 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">{percent}%</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
            {/* FARMERS */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box sx={{ bgcolor: "#f9fafb", p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="primary">FARMERS</Typography>
                {(() => {
                  const done = Number(preSeasonData?.overall_totals?.farmers_attended ?? 0);
                  const total = Number(preSeasonData?.overall_totals?.farmers_required ?? 0);
                  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
                  return (
                    <>
                      <Typography variant="body2" fontWeight={600}>{done} / {total}</Typography>
                      <Box sx={{ width: '100%', mt: 1 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">{percent}%</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Card>
      </Grid>
  </Grid>

  {/* ================= MAIN ================= */}
  <Grid container spacing={2} sx={{ mt: 2 }}>
    
    {/* LEFT */}
    <Grid item size={{ xs: 12, sm: 6 }}>
      
      {/* PRE ACTIVITIES */}
     

      {/* POST ACTIVITIES */}
      <Card sx={{ borderRadius: 3, overflow: "hidden" }}>
        {/* HEADER */}
        <Box sx={{px: 2, py: 1.5, }}>
          <Typography sx={{ fontWeight: 600, color: '#475569', letterSpacing: 1 }}>
            POST ACTIVITIES
          </Typography>
        </Box>
        {/* CONTENT */}
        <Box sx={{ p: 2 }}>
          <Grid container spacing={2}>
            {/* DV */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box sx={{ bgcolor: "#f9fafb", p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="primary">DV</Typography>
                {(() => {
                  const done = Number(postSeasonData?.overall_totals?.dv_done_count ?? 0);
                  const total = Number(postSeasonData?.overall_totals?.dv_count ?? 0);
                  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
                  return (
                    <>
                      <Typography variant="body2" fontWeight={600}>{done} / {total}</Typography>
                      <Box sx={{ width: '100%', mt: 1 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">{percent}%</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
            {/* FV */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box sx={{ bgcolor: "#f9fafb", p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="primary">FV</Typography>
                {(() => {
                  const done = Number(postSeasonData?.overall_totals?.fv_done_count ?? 0);
                  const total = Number(postSeasonData?.overall_totals?.fv_count ?? 0);
                  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
                  return (
                    <>
                      <Typography variant="body2" fontWeight={600}>{done} / {total}</Typography>
                      <Box sx={{ width: '100%', mt: 1 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">{percent}%</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
            {/* FD */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box sx={{ bgcolor: "#f9fafb", p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="primary">FD</Typography>
                {(() => {
                  const done = Number(postSeasonData?.overall_totals?.fd_done_count ?? 0);
                  const total = Number(postSeasonData?.overall_totals?.fd_count ?? 0);
                  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
                  return (
                    <>
                      <Typography variant="body2" fontWeight={600}>{done} / {total}</Typography>
                      <Box sx={{ width: '100%', mt: 1 }}>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item xs>
                            <Box sx={{ width: '100%' }}>
                              <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ borderRadius: 5, height: 8 }}
                                color={percent >= 100 ? 'success' : 'primary'}
                              />
                            </Box>
                          </Grid>
                          <Grid item>
                            <Typography variant="caption" color="#9ca3af">{percent}%</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  );
                })()}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Grid>

    {/* RIGHT SIDE */}
    <Grid item size={{ xs: 12, sm:6 }}>
      <Card sx={{ borderRadius: 3, overflow: "hidden" }}>
        {/* HEADER */}
        <Box sx={{  fontWeight: 600, color: '#475569', letterSpacing: 1 ,p:2}}>
          <Typography fontWeight={600}>DAILY TASKS</Typography>
        </Box>

        <Box sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 4 }} py={1}>
              <Box sx={{ bgcolor: "#f3f4f6", p: 1, borderRadius: 2, height: '100%' }}>
                <Typography variant="caption">TOTAL TASKS</Typography>
                <Typography variant="h5">{dailyTasksData?.total_records_count ?? 0}</Typography>
              </Box>
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }} py={1}>
              <Box sx={{ bgcolor: "#fff7ed", p: 1, borderRadius: 2, height: '100%' }}>
                <Typography variant="caption">PENDING</Typography>
                <Typography variant="h5" color="#b45309">{dailyTasksData?.assigned_task_count ?? 0}</Typography>
              </Box>
            </Grid>
            <Grid item size={{ xs: 12, sm: 4 }} py={1}>
              <Box sx={{ bgcolor: "#ecfdf5", p: 1, borderRadius: 2, height: '100%' }}>
                <Typography variant="caption">COMPLETED</Typography>
                <Typography variant="h5" color="#047857">{dailyTasksData?.completed_task_count ?? 0}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Grid>
  </Grid>
{/* </Box> */}
  
      </Box>
    </Box>
  );
};

export default SOorMDODashboard;